const { PRODUCT_STATES_CONFIG } = window;

const quickAddDrawer = () => ({
  // code may assume that product is not changing
  // during lifetime of this component

  email: '', // TODO: default to logged in user's email
  success: null,

  // coming-soon, many-variants, sold-out-permanently, sold-out-notify, available, success
  get state() {
    if (this.success) {
      return 'success';
    }

    return this.stateBase;
  },

  get buttonLabel() {
    const { state } = this;
    if (state === 'success') return this.success.buttonLabel;
    return this.buttonLabelBase;
  },

  get drawerTitle() {
    const { state } = this;
    if (state === 'success') return '';

    return 'Quick add';
  },

  get showEmailInput() {
    const { state } = this;
    return state === 'coming-soon' || state === 'sold-out-notify';
  },

  get qualifiersParsed() {
    const { qualifiers } = this.quickAddDrawerProduct;
    if (!qualifiers?.value) return '';
    try {
      return JSON.parse(qualifiers.value).join(' ');
    } catch (e) {
      return '';
    }
  },

  get metafieldPoweredTitle() {
    const { print, description, type } = this.quickAddDrawerProduct;

    return Boolean(
      print?.value &&
        ((this.qualifiersParsed && type?.value) || description?.value)
    );
  },

  get productTitle() {
    const { description, title, type } = this.quickAddDrawerProduct;

    if (this.metafieldPoweredTitle) {
      if (description?.value) return description.value;
      
      return `${this.qualifiersParsed} ${type.value}`;
    }
    
    return title;
  },

  get price() {
    return this.quickAddDrawerProduct.priceRangeFormatted;
  },

  get priceRegular() {
    return this.quickAddDrawerProduct.compareAtPriceRangeFormatted;
  },

  get pricingText() {
    return `reduced price: ${this.price}, regular price: ${this.priceRegular}`;
  },

  get hasReducedPrice() {
    const { priceRegular, price } = this;
    return (
      priceRegular &&
      priceRegular !== price
    );
  },

  get superTitle() {
    const { brand, print } = this.quickAddDrawerProduct;

    const brandNormalized =
      brand?.value && !brand.value.includes('Posh Peanut') ? brand.value : '';

    return `${brandNormalized ? `${brandNormalized} ` : ''}${print?.value || ''}`;
  },

  get medias() {
    const { images = [], title } = this.quickAddDrawerProduct;
    return (images?.nodes || [])
    .filter(node => !!node.url)
    .map((node, index) => ({
      id: node.id,
      url: node.url,
      altText: node.altText || `${title} -- Image: ${index + 1}`
    })) ?? [];
  },

  init() {
    window.quickAddDrawer = this;

    if (this.quickAddDrawerSelectedOptions) {
      Object.assign(this.selectedOptions, this.quickAddDrawerSelectedOptions);
      this.normalizeOptionsAndVariants(Object.entries(this.selectedOptions));
    }

    // don't show drawer if there are no options to select
    if (this.visibleOptions.length === 0 && this.state === 'available') {
      this.handleBottomButtonClick();
      this.$el.closest('dialog').close();
      return;
    }

    this.$dispatch('update-quick-add-drawer-title', this.drawerTitle);

    this.$watch('drawerTitle', (newTitle, oldTitle) => {
      if (newTitle === oldTitle) return;
      this.$dispatch('update-quick-add-drawer-title', newTitle);
    });
  },

  get klaviyoComingSoonListIdNormalized() {
    return this.product.comingSoonListId?.value || this.klaviyoComingSoonListId;
  },

  async handleFormSubmit() {
    if (this.isWorking) return;

    let requestTypeUrl;
    let requestData;
    if (this.isComingSoon) {
      requestTypeUrl = 'subscriptions';
      requestData = {
        type: 'subscription',
        attributes: {
          profile: {
            data: { type: 'profile', attributes: { email: this.email } },
          },
        },
        relationships: {
          list: {
            data: { type: 'list', id: this.klaviyoComingSoonListIdNormalized },
          },
        },
      };
    } else {
      const { selectedVariants, visibleOptions } = this;

      if (selectedVariants.length !== 1) {
        alert(
          `Please select a ${visibleOptions[0].name} to subscribe to back-in-stock notifications.`
        );
        return;
      }

      const [selectedVariant] = selectedVariants;

      let variantId = selectedVariant.id.replace(
        'gid://shopify/ProductVariant/',
        ''
      );

      if (window.Shopify.shop === 'poshpeanutdev.myshopify.com') {
        // hardcoded id so we can test on dev store
        variantId = '42562038333616';
      }

      requestTypeUrl = 'back-in-stock-subscriptions';
      requestData = {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: { type: 'profile', attributes: { email: this.email } },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      };
    }

    const url = `https://a.klaviyo.com/client/${requestTypeUrl}/?company_id=${this.klaviyoCompanyId}`;
    const options = {
      method: 'POST',
      headers: { revision: '2023-07-15', 'content-type': 'application/json' },
      body: JSON.stringify({ data: requestData }),
    };

    try {
      this.isWorking = true;
      const res = await fetch(url, options);

      if (!res.ok) {
        let description = '';
        try {
          const data = await res.json();
          description = data.errors.map((err) => err.detail).join('\n');
        } catch (e) {
          //
        }

        throw new Error(
          [
            'Failed to subscribe to list!',
            description,
            `(status: ${res.status})`,
          ]
            .filter(Boolean)
            .join('\n')
        );
      }

      this.success = PRODUCT_STATES_CONFIG[this.state].success;

      setTimeout(() => {
        window.quickAddDrawer?.$refs.successTitle?.focus();
      }, 0);
    } catch (error) {
      alert(error.message);
    } finally {
      this.isWorking = false;
    }
  },
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  },


  async handleBottomButtonClick() {
    if (this.isWorking) return;

    const { state } = this;
    const userStatus = this.getCookie('userStatusFacebook');

    if(userStatus == "VIP") {
      await this.addToCart({ isFacebook: true });
      this.isWorking = false;
      return
    }

    if (state === 'available' || state === 'pre-order' || state === 'back-order') {
      await this.addToCart();
      this.$el.closest('dialog').close();
    } else if (state === 'success') {
      this.$el.closest('dialog').close();
    }
  },
});

export default quickAddDrawer;
